import { Component, OnInit, ViewChild } from '@angular/core';
import { OrganizationalUnitSearchRequest } from '../../../../models/net/request/organizational-unit-search-request';
import { OrganizationalUnitSearchResult } from '../../../../models/net/result/organizational-unit-search-result';
import { AppService } from '../../../../services/app.service';
import { OrganizationalUnitService } from '../../../../services/organizational-units/organizational-unit.service';
import { SearchComponent } from '../../../base/search/search.component';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-organizations',
    templateUrl: './organizations.component.html',
    styleUrls: ['./organizations.component.css', '../../../../app.component.css']
})

export class OrganizationsComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "Name", "Delete"];
    public override searchRequest: OrganizationalUnitSearchRequest = new OrganizationalUnitSearchRequest();
    public override searchResult: OrganizationalUnitSearchResult[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.OrganizationalUnitSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: OrganizationalUnitService) {

        super(appService, sessionService, itemService, "org", "Organization");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.OrganizationalUnitSearchRequest;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: OrganizationalUnitSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: OrganizationalUnitSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: OrganizationalUnitSearchResult) => i.OrganizationalUnitId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: OrganizationalUnitSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
